// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1-uVV","label":"Radio_label__11WvX","checkMark":"Radio_checkMark__27qnz","disabled":"Radio_disabled__3hPjb"};